module.exports = () => {
  return {
    ENV: process.env.ENV,
    GOOGLE_MAPS_KEY: process.env.GOOGLE_MAPS_KEY,
    GOOGLE_MAPS_ID: process.env.GOOGLE_MAPS_ID,
    SITE: "https://www.fortepan.hu",
    SITE_DEV: "http://localhost:8888",
    DRUPAL_HOST: "https://backend.fortepan.hu",
    DRUPAL_HOST_DEV: "https://backend-develop.fortepan.hu",
    PHOTO_SOURCE: "https://fortepan.download/file/fortepan-eu/",
    PHOTO_SOURCE_LARGE: "https://fortepan.download/file/fortepan-eu/download/fortepan_",
    THUMBNAILS_QUERY_LIMIT: 40,
    BREAKPOINT_PHONE_XS: 360,
    BREAKPOINT_PHONE_SM: 480,
    BREAKPOINT_PHONE: 640,
    BREAKPOINT_TABLET: 768,
    BREAKPOINT_DESKTOP: 1024,
    BREAKPOINT_DESKTOP_LG: 1220,
    CAROUSEL_SLIDESHOW_DELAY: 4000,
    DEFAULT_THEME: "light",
    LOCALES: {
      hu: "Magyar",
      en: "English",
    },
    AGE_RESTRICTION_TAG: "18+",
    YEAR_MIN: "1900",
    YEAR_MAX: "1990",
    ADVANCED_SEARCH_KEYS: [
      "country",
      "city",
      "place",
      "location",
      "description",
      "donor",
      "photographer",
      "tag",
      "id",
      "year",
      "year_from",
      "year_to",
    ],
    // locations offered as a group (e.g. "Budapest" + "Budapest I.", "Budapest II.", …) in the advanced search autosuggest
    GROUPED_LOCATIONS: ["Budapest"],
  }
}
